export const SUBSCRIPTION_GROUPS = {
  premium: 'premium'
};
